<template>
  <div class="chemtracker-module">
    <fieldset v-if="typeof chemicalContainer !== 'undefined'">
      <legend>Container Data</legend>
      <b-row>
        <b-col>
          <span class="raftjs-entity-view-label">Chemical Name: </span>
          {{ getChemicalName }}
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <span class="raftjs-entity-view-label">Product Name: </span>
          {{ getProductName }}
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <span class="raftjs-entity-view-label">Product Number: </span>
          {{ getProductNumber }}
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <span class="raftjs-entity-view-label">Manufacturer: </span>
          {{ getManufacturerName }}
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <span class="raftjs-entity-view-label">Container ID: </span>
          {{ getContainerId }}
        </b-col>
      </b-row>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: "ChemicalContainerDetails",
  data() {
    return {};
  },
  computed: {
    getContainerId: function () {
      if (
        this.chemicalContainer &&
        this.chemicalContainer.hasOwnProperty("field_chemical_container_id")
      ) {
        return this.chemicalContainer.field_chemical_container_id;
      }
      return "";
    },
    getChemicalName: function () {
      if (
        this.chemicalContainer &&
        this.chemicalContainer.hasOwnProperty("field_chemical_name_preferred")
      ) {
        return this.chemicalContainer.field_chemical_name_preferred;
      }
      return "";
    },
    getProductName: function () {
      if (
        this.chemicalContainer &&
        this.chemicalContainer.hasOwnProperty("field_chemical_product_name")
      ) {
        return this.chemicalContainer.field_chemical_product_name;
      }
      return "";
    },
    getProductNumber: function () {
      if (
        this.chemicalContainer &&
        this.chemicalContainer.hasOwnProperty("field_chemical_product_number")
      ) {
        return this.chemicalContainer.field_chemical_product_number;
      }
      return "";
    },
    getManufacturerName: function () {
      if (
        this.chemicalContainer &&
        this.chemicalContainer.field_chemical_manufacturer &&
        this.chemicalContainer.field_chemical_manufacturer.hasOwnProperty(
          "name",
        )
      ) {
        return this.chemicalContainer.field_chemical_manufacturer.name;
      }
      return "";
    },
  },
  props: {
    chemicalContainer: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped></style>
